export const factoriesForInput = [
  {
    id: 50,
    name: "本社工場",
  },
  {
    id: 51,
    name: "本巣工場",
  },
  {
    id: 52,
    name: "福岡工場",
  },
  {
    id: 53,
    name: "熊本工場",
  },
  {
    id: 54,
    name: "関東工場",
  },
  {
    id: 55,
    name: "屋井工場",
  },
];

export const factoriesForSelect = [
  {
    id: 0,
    name: "ずべて",
  },
  {
    id: 50,
    name: "本社工場",
  },
  {
    id: 51,
    name: "本巣工場",
  },
  {
    id: 52,
    name: "福岡工場",
  },
  {
    id: 53,
    name: "熊本工場",
  },
  {
    id: 54,
    name: "関東工場",
  },
  {
    id: 55,
    name: "屋井工場",
  },
];
